import { SeverityAssessment, Questionnaire, Question } from '../../hickory-api';

export class TextResource {
  id: string;
  text: string;

  withId(id: string) {
    this.id = id;
    return this;
  }
  withText(text: string) {
    this.text = text;
    return this;
  }
}

export class SeverityQuestionOptions {
  question: TextResource;
  answer: TextResource;
  options: TextResource[];
  required: boolean = true;

  withRequired(required: boolean) {
    this.required = required;
    return this;
  }

  withQuestion(question: TextResource) {
    this.question = question;
    return this;
  }

  withAnswer(answer: TextResource) {
    this.answer = answer;
    return this;
  }

  withOptions(options: TextResource[]) {
    this.options = options;
    return this;
  }

  clone(): SeverityQuestionOptions {
    return new SeverityQuestionOptions()
      .withQuestion(this.question)
      .withAnswer(this.answer)
      .withOptions(this.options)
      .withRequired(this.required);
  }

  fromQuestion(question: Question): SeverityQuestionOptions {
    this.question = new TextResource().withId(question.id).withText(question.text);
    this.options = [];
    for (const option of question.options) {
      const optionResource = new TextResource().withId(option.id).withText(option.text);
      this.options.push(optionResource);
    }
    return this;
  }
}

export class SeverityModel {
  questions: SeverityQuestionOptions[];
  comments: string;
  requireComments: boolean = false;

  get isValid() {
    return !(this.requireComments && !this.comments ||
      (this.questions as SeverityQuestionOptions[]).some(q => q.required && !q.answer));
  }

  withQuestions(questions: SeverityQuestionOptions[]) {
    this.questions = questions;
    return this;
  }

  clone(): SeverityModel {
    const clone = new SeverityModel().withQuestions(this.questions.map(q => q.clone()));
    clone.comments = this.comments;
    clone.requireComments = this.requireComments;
    return clone;
  }

  fromQuestionnaire(questionnaire: Questionnaire): SeverityModel {
    this.questions = [];
    for (const q of questionnaire.questions) {
      this.questions.push(new SeverityQuestionOptions().fromQuestion(q));
    }
    return this;
  }

  convertToSeverityAssessment(): SeverityAssessment {
    const assessment: SeverityAssessment = {
      comment: this.comments,
      responses: null,
    };
    if (this.questions) {
      assessment.responses = this.questions.map(q => {
        return {
          questionId: q.question?.id,
          question: q.question?.text,
          optionId: q.answer?.id,
          option: q.answer?.text
        };
      });
    }
    return assessment;
  }
}

export interface BundleAssessment {
  responses: any[];
  options: any[];
  questions: BundleAssessmentQuestion[];
}

export interface BundleAssessmentQuestion {
  id: string;
  comment: string;
  question: string;
  optionsId: string;
}